import { render, staticRenderFns } from "./RowMenu.vue?vue&type=template&id=0003b3c9"
import script from "./RowMenu.vue?vue&type=script&lang=js"
export * from "./RowMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports